import React, { Component } from "react";
import { gql } from "@apollo/client";

import "./FileListView.scss";
import ListViewRows from "../../ListView/ListViewRows/ListViewRows";
import ListViewHeader from "../../ListView/ListViewHeader/ListViewHeader";
import Spinner from "react-bootstrap/Spinner";
import DocumentView from "../../DocumentView/DocumentView";
import { apolloClient } from "../../../index";
import { notify } from "../../Notify/Notify";

class FileListView extends Component {
  state = {
    recentlyEdited: [],
    heading: ["Files", "Activity", "User", "Last modified", "Shared with"],
    isColumns: {
      isTitle: true,
      isFolder: true,
      isActivity: true,
      isLastModified: true,
      isShared: true,
      isPopover: true,
      isUserName: true,
    },
    tableSizeLarge: false,
    showDocumentDetailModal: false,
    documentDetailModalInfo: {},
    loading: true,
  };

  componentDidMount() {
    apolloClient
      .query({
        query: gql`
          query recentlyEdited($first: Int) {
            recentlyEdited(first: $first) {
              folder{
                id
                isRoot
                title
                color {
                  name
                }
                modifiedTs
                modifiedBy {
                  username
                  firstName
                  lastName
                  profile {
                    image
                    role {
                      name
                    }
                  }
                }
                parentFolder {
                  id
                }
                sharedFolder {
                  id
                  user {
                    id
                    email
                    username
                    firstName
                    lastName
                    profile {
                      image
                      role {
                        id
                        name
                      }
                    }
                  }
                  userRole {
                    id
                    name
                  }
                }
                userActionOnFolder {
                  action {
                    name
                  }
                }
              }
              document {
                id
                title
                fileUrl
                isArchive
                folder {
                  id
                  parentFolder {
                    id
                  }
                }
                isArchive
                documentType {
                  id
                  title
                }
                status {
                  id
                  name
                }
                modifiedBy {
                  email
                  firstName
                  lastName
                  profile {
                    image
                    role {
                      id
                      name
                    }
                  }
                }
                createdBy {
                  email
                  firstName
                  lastName
                  profile {
                    image
                    role {
                      id
                      name
                    }
                  }
                }
                sharedDocument {
                  id
                  user {
                    id
                    email
                    username
                    firstName
                    lastName
                    profile {
                      image
                      role {
                        id
                        name
                      }
                    }
                  }
                  userRole {
                    id
                    name
                  }
                }
                userActionOnDocument {
                  id
                  action {
                    name
                  }
                }
                modifiedTs
                abstractJson
              }
            }
          }
        `,
        variables: {
          first: 4,
        },
      })
      .then((result) => {
        const { folder, document } = result.data.recentlyEdited;
        let recentlyEdited = [];
        if (folder) {
          recentlyEdited = [...recentlyEdited, ...folder];
        }

        if (document) {
          recentlyEdited = [...recentlyEdited, ...document];
        }
        recentlyEdited.sort((item1, item2) => {
          return new Date(item1.modifiedTs) < new Date(item2.modifiedTs) ? 1 : -1;
        });
        this.setState({ recentlyEdited, loading: false });
      })
      .catch((e) => {
        const detail = "Error";
        const title = "oops! something went wrong";
        const type = "error";
        const recentlyEdited = [];
        this.setState(
          { recentlyEdited, loading: false },
          notify(detail, title, type)
        );
      });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.recentlyEdited !== this.props.recentlyEdited) {
      if (this.props.recentlyEdited) {
        const recentlyEdited = [...this.state.recentlyEdited];
        recentlyEdited.unshift(this.props.recentlyEdited);
        this.setState({ recentlyEdited });
      }
    }
  }

  onDocumentClick = (id) => {
    const document = this.state.recentlyEdited.filter(
      (item) => item.id === id
    )[0];
    const doc = { ...document };
    doc.abstractJson = JSON.parse(doc.abstractJson);
    const documentDetailModalInfo = {
      title: document.title,
      fileUrl: document.fileUrl,
      documentObj: doc,
      viewOnly: true,
    };
    this.setState({ documentDetailModalInfo, showDocumentDetailModal: true });
  };
  getActivity = (item) => {
    if (item.folder) {
      return (
        item.userActionOnDocument.length > 0 &&
        item.userActionOnDocument[item.userActionOnDocument.length - 1].action
          .name === "Archived" ? "Restored" : item.userActionOnDocument[item.userActionOnDocument.length - 1].action.name
      );
    } else {
      return (
        item.userActionOnFolder.length > 0 &&
        item.userActionOnFolder[item.userActionOnFolder.length - 1].action.name
      );
    }
  };

  render() {
    return (
      <div className="row mt-12 pb-12">
        <div className="col-md">
          <div className="row">
            {/* Title */}
            <div className="col-md pl-6">
              <h6> {this.props.itemsTitle} </h6>
            </div>
          </div>
          <DocumentView
            calendarView={true}
            showModal={this.state.showDocumentDetailModal}
            handleClose={() => {
              this.setState({ showDocumentDetailModal: false });
            }}
            {...this.state.documentDetailModalInfo}
            userRoleId={this.props.userRoleId}
            currentUserInfo={this.props.currentUserInfo}
          />

          <div className="row">
            <div className="col-md pl-6">
              {/* Table header */}
              <div className="table-responsive-md list-view-row">
                {!this.state.loading ? (
                  this.state.recentlyEdited.length > 0 && (
                    <table className="table table-hover">
                      <thead className="table-borderless">
                        <tr className="list-view-header">
                          {this.state.heading.map((headKey) => (
                            <ListViewHeader
                              key={headKey}
                              columnName={headKey}
                            />
                          ))}
                        </tr>
                      </thead>

                      {/* Table Rows */}
                      <tbody>
                        {this.state.recentlyEdited
                          .slice(0, 4)
                          .map((rKey, index) => (
                            <ListViewRows
                              key={index}
                              item={rKey}
                              isColumns={this.state.isColumns}
                              size={this.state.tableSizeLarge}
                              isFolder={
                                !rKey.folder
                              }
                              rootFolderId={
                                rKey.folder
                                  ? rKey.folder.parentFolder.id
                                  : rKey.parentFolder
                                  ? rKey.parentFolder.id
                                  : rKey.id
                              }
                              subFolderId={
                                "parentFolder" in rKey
                                  ? rKey.id
                                  : rKey.folder.id
                              }
                              activity={this.getActivity(rKey)}
                              onDocumentClick={this.onDocumentClick}
                              recentlyEditedView={true}
                            />
                          ))}
                      </tbody>
                    </table>
                  )
                ) : (
                  <div
                    // className="progress-icon"
                    style={{ textAlign: "center" }}
                  >
                    <Spinner animation="border" role="status" />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default FileListView;
